import {decorate, observable} from 'mobx';
import moment from 'moment';
import i18n from '../i18n/i18n';
import {BaseModel} from './base';
import {displayableProperty} from './displayableProperty';
import {displayablePropertyParam} from './displayablePropertyParam';
import {transformation} from '../utils/transformations';
import {datetimeFormat} from '../config/moment';

export const WorkplaceStateLogAssociations = {
  state: 'state',
  workplace: 'workplace',
  interruptionReason: 'interruptionReason',
};

export class WorkplaceStateLog extends BaseModel {
  populateAttributesFromStore(rootStore) {
    this.state = rootStore.workplaceStateStore.getById(this.stateId);
    this.interruptionReason = rootStore.interruptionReasonStore.getById(this.interruptionReasonId);
    this.workplace = rootStore.workplaceStore.getById(this.workplaceId);
    this.createdByUser = rootStore.userStore.getById(this.createdBy);

    if (this.start) {
      this.durationSeconds = moment.duration(
        moment((this.end) ? this.end : moment())
          .diff(moment(this.start), 'seconds'), 'seconds'
      );
    }

    this.active = !this.end;

    return super.populateAttributesFromStore(rootStore);
  }

  displayableProperties = [
    displayableProperty({
      title: i18n.t('operationStateLog.model.attributes.start'),
      params: [
        displayablePropertyParam({
          path: 'start', transform: transformation.datetime({format: datetimeFormat}),
        }),
      ],
      template: '{value}',
      key: 'start',
      raw: false,
    }),
    displayableProperty({
      title: i18n.t('operationStateLog.model.attributes.durationSeconds'),
      params: [
        displayablePropertyParam({
          path: 'durationSeconds', transform: transformation.detailedDuration,
        }),
      ],
      template: '{value}',
      key: 'durationSeconds',
      raw: false,
    }),
    displayableProperty({
      title: i18n.t('operationStateLog.model.attributes.active'),
      params: [
        displayablePropertyParam({
          path: 'active', transform: transformation.none,
        }),
      ],
      template: '{value}',
      key: 'active',
      raw: false,
    }),
  ];
}

decorate(WorkplaceStateLog, {
  id: observable,
  workplaceId: observable,
  stateId: observable,
  state: observable,
  interruptionReasonId: observable,
  interruptionReason: observable,
  start: observable,
  end: observable,
  message: observable,
  durationSeconds: observable,
  active: observable,
  tags: observable,
});
